import {
  ADMIN_KPI_PRIMARY_AWARENESS,
  ADMIN_KPI_PRIMARY_CONVERSIONS,
  ADMIN_KPI_PRIMARY_DOWNLOADS,
  ADMIN_KPI_PRIMARY_INTERACTIONS,
  ADMIN_KPI_PRIMARY_LEADS,
  ADMIN_KPI_PRIMARY_MESSAGES,
  ADMIN_KPI_PRIMARY_REACH,
  ADMIN_KPI_PRIMARY_SALES,
  ADMIN_KPI_PRIMARY_STORE_VISITS,
  ADMIN_KPI_PRIMARY_TRAFFIC,
  ADMIN_KPI_PRIMARY_VIDEO_VIEWS,
} from "../../../i18n/keysTranslations";
import {
  ADS_CAMPAIGN_META_DESTINATION_TYPE_CATALOG_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_GOOGLE_PLAY_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_STORE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_INSTAGRAM_PROFILE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_FROM_IG_DIRECT_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_INSTANT_FORM_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_AND_MESSENGER_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_MESSAGE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_APP_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_IN_STORE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WHATSAPP_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPES_WEBSITE,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS_OPTION,
  ADS_CAMPAIGN_TYPE_APP_OPTION,
  ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_OPTION,
  ADS_CAMPAIGN_TYPE_SEARCH_OPTION,
  GOOGLE,
  LINKEDIN,
  META,
  TIKTOK,
} from "../../../utils/constants";

/** Canonical measurable KPI ids used internally for eligibility rules */
export const MEASURABLE_KPI_CANONICAL = {
  AWARENESS: "awareness",
  REACH: "reach",
  TRAFFIC: "traffic",
  ENGAGEMENT: "engagement",
  LEADS: "leads",
  SALES: "sales",
  MESSAGES: "messages",
  CONVERSIONS: "conversions",
  DOWNLOADS: "downloads",
  VIDEO_VIEWS: "videoViews",
  STORE_VISITS: "storeVisits",
};

const ADMIN_KPI_TO_CANONICAL = {
  [ADMIN_KPI_PRIMARY_LEADS]: MEASURABLE_KPI_CANONICAL.LEADS,
  [ADMIN_KPI_PRIMARY_SALES]: MEASURABLE_KPI_CANONICAL.SALES,
  [ADMIN_KPI_PRIMARY_MESSAGES]: MEASURABLE_KPI_CANONICAL.MESSAGES,
  [ADMIN_KPI_PRIMARY_INTERACTIONS]: MEASURABLE_KPI_CANONICAL.ENGAGEMENT,
  [ADMIN_KPI_PRIMARY_TRAFFIC]: MEASURABLE_KPI_CANONICAL.TRAFFIC,
  [ADMIN_KPI_PRIMARY_CONVERSIONS]: MEASURABLE_KPI_CANONICAL.CONVERSIONS,
  [ADMIN_KPI_PRIMARY_DOWNLOADS]: MEASURABLE_KPI_CANONICAL.DOWNLOADS,
  [ADMIN_KPI_PRIMARY_VIDEO_VIEWS]: MEASURABLE_KPI_CANONICAL.VIDEO_VIEWS,
  [ADMIN_KPI_PRIMARY_AWARENESS]: MEASURABLE_KPI_CANONICAL.AWARENESS,
  [ADMIN_KPI_PRIMARY_REACH]: MEASURABLE_KPI_CANONICAL.REACH,
  [ADMIN_KPI_PRIMARY_STORE_VISITS]: MEASURABLE_KPI_CANONICAL.STORE_VISITS,
};

const META_MESSAGE_DESTINATIONS = new Set([
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WHATSAPP_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_MESSAGE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_AND_MESSENGER_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_FROM_IG_DIRECT_OPTION,
]);

const META_IN_STORE_DESTINATIONS = new Set([
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_IN_STORE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE_OPTION,
]);

const META_WEB_DESTINATIONS = new Set([
  ...ADS_CAMPAIGN_META_DESTINATION_TYPES_WEBSITE,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_CATALOG_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_APP_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_OPTION,
]);

const META_APP_DESTINATIONS = new Set([
  ADS_CAMPAIGN_META_DESTINATION_TYPE_GOOGLE_PLAY_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_STORE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_APP_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE_OPTION,
]);

const GOOGLE_CATEGORY_TO_CANONICAL = {
  PURCHASE: [
    MEASURABLE_KPI_CANONICAL.SALES,
    MEASURABLE_KPI_CANONICAL.CONVERSIONS,
  ],
  STORE_SALE: [
    MEASURABLE_KPI_CANONICAL.SALES,
    MEASURABLE_KPI_CANONICAL.CONVERSIONS,
    MEASURABLE_KPI_CANONICAL.STORE_VISITS,
  ],
  STORE_VISIT: [
    MEASURABLE_KPI_CANONICAL.STORE_VISITS,
    MEASURABLE_KPI_CANONICAL.CONVERSIONS,
  ],
  QUALIFIED_LEAD: [
    MEASURABLE_KPI_CANONICAL.LEADS,
    MEASURABLE_KPI_CANONICAL.CONVERSIONS,
  ],
  SUBMIT_LEAD_FORM: [
    MEASURABLE_KPI_CANONICAL.LEADS,
    MEASURABLE_KPI_CANONICAL.CONVERSIONS,
  ],
  BOOK_APPOINTMENT: [
    MEASURABLE_KPI_CANONICAL.LEADS,
    MEASURABLE_KPI_CANONICAL.CONVERSIONS,
  ],
  IMPORTED_LEAD: [
    MEASURABLE_KPI_CANONICAL.LEADS,
    MEASURABLE_KPI_CANONICAL.CONVERSIONS,
  ],
  CONVERTED_LEAD: [
    MEASURABLE_KPI_CANONICAL.LEADS,
    MEASURABLE_KPI_CANONICAL.CONVERSIONS,
  ],
  PAGE_VIEW: [
    MEASURABLE_KPI_CANONICAL.TRAFFIC,
    MEASURABLE_KPI_CANONICAL.CONVERSIONS,
  ],
  OUTBOUND_CLICK: [
    MEASURABLE_KPI_CANONICAL.TRAFFIC,
    MEASURABLE_KPI_CANONICAL.CONVERSIONS,
  ],
  DOWNLOAD: [
    MEASURABLE_KPI_CANONICAL.DOWNLOADS,
    MEASURABLE_KPI_CANONICAL.CONVERSIONS,
  ],
  SIGNUP: [
    MEASURABLE_KPI_CANONICAL.LEADS,
    MEASURABLE_KPI_CANONICAL.CONVERSIONS,
  ],
  ENGAGEMENT: [
    MEASURABLE_KPI_CANONICAL.ENGAGEMENT,
    MEASURABLE_KPI_CANONICAL.CONVERSIONS,
  ],
  ADD_TO_CART: [
    MEASURABLE_KPI_CANONICAL.SALES,
    MEASURABLE_KPI_CANONICAL.CONVERSIONS,
  ],
  BEGIN_CHECKOUT: [
    MEASURABLE_KPI_CANONICAL.SALES,
    MEASURABLE_KPI_CANONICAL.CONVERSIONS,
  ],
  GET_DIRECTIONS: [
    MEASURABLE_KPI_CANONICAL.STORE_VISITS,
    MEASURABLE_KPI_CANONICAL.TRAFFIC,
    MEASURABLE_KPI_CANONICAL.CONVERSIONS,
  ],
  PHONE_CALL_LEAD: [
    MEASURABLE_KPI_CANONICAL.LEADS,
    MEASURABLE_KPI_CANONICAL.MESSAGES,
    MEASURABLE_KPI_CANONICAL.CONVERSIONS,
  ],
  CONTACT: [
    MEASURABLE_KPI_CANONICAL.LEADS,
    MEASURABLE_KPI_CANONICAL.CONVERSIONS,
  ],
};

const PLATFORM_ALIASES = {
  [META]: META,
  meta: META,
  [TIKTOK]: TIKTOK,
  tiktok: TIKTOK,
  [GOOGLE]: GOOGLE,
  google: GOOGLE,
  [LINKEDIN]: LINKEDIN,
  linkedin: LINKEDIN,
  linkedIn: LINKEDIN,
};

export const normalizeGlobalReportPlatform = (platform) => {
  if (platform == null || platform === "") {
    return "";
  }
  return PLATFORM_ALIASES[platform] || String(platform).toLowerCase();
};

export const platformKeysMatch = (platformA, platformB) =>
  normalizeGlobalReportPlatform(platformA) ===
  normalizeGlobalReportPlatform(platformB);

export const adminKpiKeyToCanonical = (adminKpiKey) => {
  if (typeof adminKpiKey !== "string" || !adminKpiKey.trim()) {
    return null;
  }
  const trimmed = adminKpiKey.trim();
  return ADMIN_KPI_TO_CANONICAL[trimmed] || trimmed;
};

export const measurableKpiKeysMatch = (measurableKpi, primaryKpi) => {
  if (!measurableKpi || !primaryKpi) {
    return false;
  }
  return (
    adminKpiKeyToCanonical(measurableKpi) === adminKpiKeyToCanonical(primaryKpi)
  );
};

const getCampaignAdGroups = (campaign = {}) => {
  const { adsGroups } = campaign;
  if (Array.isArray(adsGroups)) {
    return adsGroups;
  }
  if (adsGroups && typeof adsGroups === "object") {
    return Object.values(adsGroups);
  }
  return [];
};

const getMetaDestinationTypes = (campaign = {}) => {
  const destinations = new Set();
  getCampaignAdGroups(campaign).forEach((adGroup) => {
    if (
      platformKeysMatch(adGroup?.platform, META) &&
      adGroup?.destinationType
    ) {
      destinations.add(adGroup.destinationType);
    }
  });
  return destinations;
};

const getGoogleConversionCategories = (platformData = {}) => {
  const categories = new Set();
  (platformData.conversionActions || []).forEach((action) => {
    if (action?.category) {
      categories.add(String(action.category).trim());
    }
  });
  return categories;
};

const getLinkedInConversionSignals = (platformData = {}) => {
  const types = new Set();
  const categories = new Set();
  (platformData.conversionActions || []).forEach((action) => {
    if (action?.type) {
      types.add(String(action.type).trim());
    }
    if (action?.category) {
      categories.add(String(action.category).trim());
    }
  });
  return { types, categories };
};

const googleCategoriesMatchCanonical = (categories, canonical) =>
  [...categories].some((category) =>
    (GOOGLE_CATEGORY_TO_CANONICAL[category] || []).includes(canonical)
  );

const metaHasAnyDestination = (destinations, allowed) =>
  [...destinations].some((destination) => allowed.has(destination));

const isMetaEligible = (campaign, canonical) => {
  const platformData = campaign?.platformsData?.[META] || {};
  const objective = platformData.objective;
  const destinations = getMetaDestinationTypes(campaign);
  const hasMessageDest = metaHasAnyDestination(
    destinations,
    META_MESSAGE_DESTINATIONS
  );
  const hasWebDest =
    metaHasAnyDestination(destinations, META_WEB_DESTINATIONS) ||
    platformData.isCatalogCampaign;
  const hasInStoreDest = metaHasAnyDestination(
    destinations,
    META_IN_STORE_DESTINATIONS
  );
  const hasAppDest = metaHasAnyDestination(destinations, META_APP_DESTINATIONS);
  const hasInstantForm = destinations.has(
    ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_INSTANT_FORM_OPTION
  );

  switch (canonical) {
    case MEASURABLE_KPI_CANONICAL.AWARENESS:
    case MEASURABLE_KPI_CANONICAL.REACH:
      return objective === ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION;
    case MEASURABLE_KPI_CANONICAL.TRAFFIC:
      return (
        objective === ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION && !hasMessageDest
      );
    case MEASURABLE_KPI_CANONICAL.MESSAGES:
      return hasMessageDest;
    case MEASURABLE_KPI_CANONICAL.ENGAGEMENT:
      return objective === ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION;
    case MEASURABLE_KPI_CANONICAL.LEADS:
      return (
        objective === ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION ||
        hasInstantForm ||
        destinations.has(
          ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_FROM_IG_DIRECT_OPTION
        )
      );
    case MEASURABLE_KPI_CANONICAL.SALES:
      return (
        objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION ||
        (objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION &&
          (hasAppDest || hasWebDest))
      );
    case MEASURABLE_KPI_CANONICAL.CONVERSIONS:
      return (
        objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION ||
        objective === ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION ||
        objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION ||
        hasInstantForm ||
        platformData.isCatalogCampaign
      );
    case MEASURABLE_KPI_CANONICAL.DOWNLOADS:
      return (
        objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION || hasAppDest
      );
    case MEASURABLE_KPI_CANONICAL.STORE_VISITS:
      return (
        hasInStoreDest ||
        destinations.has(
          ADS_CAMPAIGN_META_DESTINATION_TYPE_INSTAGRAM_PROFILE_OPTION
        )
      );
    case MEASURABLE_KPI_CANONICAL.VIDEO_VIEWS:
      return objective === ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION;
    default:
      return false;
  }
};

const isTikTokEligible = (campaign, canonical) => {
  const platformData = campaign?.platformsData?.[TIKTOK] || {};
  const { objective } = platformData;

  switch (canonical) {
    case MEASURABLE_KPI_CANONICAL.AWARENESS:
    case MEASURABLE_KPI_CANONICAL.REACH:
      return objective === ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION;
    case MEASURABLE_KPI_CANONICAL.TRAFFIC:
      return objective === ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION;
    case MEASURABLE_KPI_CANONICAL.ENGAGEMENT:
      return objective === ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION;
    case MEASURABLE_KPI_CANONICAL.VIDEO_VIEWS:
      return (
        objective === ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION ||
        objective === ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION
      );
    case MEASURABLE_KPI_CANONICAL.LEADS:
      return objective === ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION;
    case MEASURABLE_KPI_CANONICAL.SALES:
      return objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION;
    case MEASURABLE_KPI_CANONICAL.CONVERSIONS:
      return (
        objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION ||
        objective === ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION
      );
    case MEASURABLE_KPI_CANONICAL.DOWNLOADS:
      return objective === ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION;
    default:
      return false;
  }
};

const isGoogleEligible = (campaign, canonical) => {
  const platformData = campaign?.platformsData?.[GOOGLE] || {};
  const categories = getGoogleConversionCategories(platformData);

  if (categories.size > 0) {
    return googleCategoriesMatchCanonical(categories, canonical);
  }

  const { objective } = platformData;

  if (objective === ADS_CAMPAIGN_TYPE_APP_OPTION) {
    return (
      canonical === MEASURABLE_KPI_CANONICAL.DOWNLOADS ||
      canonical === MEASURABLE_KPI_CANONICAL.CONVERSIONS
    );
  }

  if (
    objective === ADS_CAMPAIGN_TYPE_SEARCH_OPTION ||
    objective === ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_OPTION
  ) {
    return (
      canonical === MEASURABLE_KPI_CANONICAL.CONVERSIONS ||
      canonical === MEASURABLE_KPI_CANONICAL.TRAFFIC ||
      canonical === MEASURABLE_KPI_CANONICAL.LEADS ||
      canonical === MEASURABLE_KPI_CANONICAL.SALES
    );
  }

  return canonical === MEASURABLE_KPI_CANONICAL.CONVERSIONS;
};

const isLinkedInEligible = (campaign, canonical) => {
  const platformData = campaign?.platformsData?.[LINKEDIN] || {};
  const { objective } = platformData;
  const { types, categories } = getLinkedInConversionSignals(platformData);
  const hasQualifiedLead =
    types.has("QUALIFIED_LEAD") || categories.has("QUALIFIED_LEAD");

  if (categories.size > 0) {
    if (googleCategoriesMatchCanonical(categories, canonical)) {
      return true;
    }
  }

  switch (canonical) {
    case MEASURABLE_KPI_CANONICAL.AWARENESS:
    case MEASURABLE_KPI_CANONICAL.REACH:
      return objective === ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION;
    case MEASURABLE_KPI_CANONICAL.TRAFFIC:
      return objective === ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION;
    case MEASURABLE_KPI_CANONICAL.ENGAGEMENT:
      return objective === ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION;
    case MEASURABLE_KPI_CANONICAL.VIDEO_VIEWS:
      return objective === ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS_OPTION;
    case MEASURABLE_KPI_CANONICAL.LEADS:
      return (
        objective === ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION || hasQualifiedLead
      );
    case MEASURABLE_KPI_CANONICAL.SALES:
    case MEASURABLE_KPI_CANONICAL.CONVERSIONS:
      if (objective === ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS_OPTION) {
        return (
          categories.size > 0 ||
          types.size > 0 ||
          canonical === MEASURABLE_KPI_CANONICAL.CONVERSIONS
        );
      }
      return (
        objective === ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS_OPTION ||
        hasQualifiedLead
      );
    default:
      return false;
  }
};

export const isPlatformEligibleForMeasurableKpi = ({
  campaign,
  platform,
  measurableKpiKey,
}) => {
  const canonical = adminKpiKeyToCanonical(measurableKpiKey);
  if (!canonical || !campaign || !platform) {
    return false;
  }

  const normalizedPlatform = normalizeGlobalReportPlatform(platform);

  if (normalizedPlatform === META) {
    return isMetaEligible(campaign, canonical);
  }
  if (normalizedPlatform === TIKTOK) {
    return isTikTokEligible(campaign, canonical);
  }
  if (normalizedPlatform === GOOGLE) {
    return isGoogleEligible(campaign, canonical);
  }
  if (normalizedPlatform === LINKEDIN) {
    return isLinkedInEligible(campaign, canonical);
  }

  return false;
};

export const getEligiblePlatformsForCampaign = (campaign, measurableKpiKey) => {
  const platforms = Array.isArray(campaign?.platforms)
    ? campaign.platforms
    : [];

  if (!measurableKpiKey) {
    return platforms;
  }

  return platforms.filter((platform) =>
    isPlatformEligibleForMeasurableKpi({
      campaign,
      platform,
      measurableKpiKey,
    })
  );
};
